import { v1 as uuid } from 'uuid';
import secondaryItems from './secondaryItems';
import ROUTES from '../../../../components/Routes/constants';
import { context, TradeState } from '../../../../_shared/types/trade';

export default {
  primary: {
    context: undefined,
    items: [
      {
        id: uuid(),
        testId: 'nav-home',
        linkTo: ROUTES.HOME,
        labelKey: 'nav.home',
        label: 'Home',
        labelFr: 'Accueil',
        context: context.home
      },
      {
        id: uuid(),
        testId: 'nav-buying',
        linkTo: ROUTES.BUYING,
        labelKey: 'nav.buying',
        label: 'Buying',
        labelFr: 'Achat',
        context: TradeState.active
      },
      {
        id: uuid(),
        testId: 'nav-selling',
        linkTo: ROUTES.SELLING,
        labelKey: 'nav.selling',
        label: 'Selling',
        labelFr: 'Vente',
        context: context.selling
      },
      {
        id: uuid(),
        testId: 'nav-research',
        linkTo: ROUTES.RESEARCH,
        labelKey: 'nav.research',
        label: 'Research',
        labelFr: 'Recherche',
        context: context.research
      },
      {
        id: uuid(),
        testId: 'nav-create',
        linkTo: ROUTES.CREATE,
        labelKey: 'nav.create',
        label: 'Create',
        labelFr: 'Créer',
        context: context.create
      }
    ],
    position: {
      left: 'auto',
      width: 'auto'
    }
  },
  secondary: {
    context: TradeState.active,
    items: secondaryItems,
    position: {
      left: 'auto',
      width: 'auto'
    }
  }
};
